<nz-select 
    nzMode="multiple" 
    nzPlaceHolder="Please select"
    [(ngModel)]="value" 
    (nzOnSearch)="search($event)" 
    (nzOpenChange)="search('')" 
    (ngModelChange)="valueChanged($event)"
    name="taxcodes" 
    [nzAutoClearSearchValue] 
    nzAllowClear
    [nzDropdownRender]="loadingTpl" 
    class="width-100">
    <ng-container *ngFor="let o of taxList">
        <nz-option [nzValue]="o.code" [nzLabel]="o.code" nzCustomContent>
            <div class="dropdown-container">
                <strong>{{ o.code }}</strong>
                <span *ngIf="o.name && o.name.trim() !== ''"> : </span>
            </div>
        </nz-option>
    </ng-container>

</nz-select>

<ng-template #loadingTpl>
    <div *ngIf="searching">
        <nz-spin></nz-spin>
        Loading
    </div>
</ng-template>